import {
    SET_PRECEDENCE_TIER_SUCCESS,
    SET_PRECEDENCE_TIER_FAILURE,
    SET_DATASET_ROLE_SUCCESS,
    SET_DATASET_ROLE_FAILURE,
    TRUNCATE_DATASET_SUCCESS,
    TRUNCATE_DATASET_FAILURE,
    NOMINATE_GOLDEN_NOMINAL_SUCCESS,
    NOMINATE_GOLDEN_NOMINAL_FAILURE,
    DENOMINATE_GOLDEN_NOMINAL_SUCCESS,
    DENOMINATE_GOLDEN_NOMINAL_FAILURE,
    GET_GOLDEN_STEWARDSHIP_PERMISSION_SUCCESS,
    GET_GOLDEN_STEWARDSHIP_PERMISSION_FAILURE,
    NO_GOLDEN_STEWARDSHIP_PERMISSION,
} from "./actions";

const initialState = {
    // In-session overrides only: { [schemaId]: dataSetId | null }. `null` means "revoked this
    // session" (so the UI stops showing a stale golden flag before a re-fetch). Golden status on
    // first load comes from each dataset's own `isGoldenNominal` flag, combined via
    // common/goldenNominal `isDatasetGolden`.
    goldenBySchema: {},
    // In-session tier overrides after a set/clear: { [dataSetId]: tier | null }.
    tierByDataSet: {},
    nominateResult: { success: true },
    denominateResult: { success: true },
    setTierResult: { success: true },
    // PRE-2797 — in-session: { [dataSetId]: role | null }, the latest role change, and the latest
    // truncate started ({ dataSetId, jobId }).
    roleByDataSet: {},
    setRoleResult: { success: true },
    truncateResult: { success: true },
    // Nothing is allowed until the user's permission has been read.
    goldenStewardshipPermission: NO_GOLDEN_STEWARDSHIP_PERMISSION,
};

export default (state = initialState, action) => {
    switch (action.type) {
        case NOMINATE_GOLDEN_NOMINAL_SUCCESS: {
            const goldenBySchema = { ...state.goldenBySchema, [action.payload.schemaId]: action.payload.dataSetId };
            return { ...state, goldenBySchema, nominateResult: { success: true } };
        }
        case NOMINATE_GOLDEN_NOMINAL_FAILURE:
            return { ...state, nominateResult: { success: false, ...action.payload } };
        case DENOMINATE_GOLDEN_NOMINAL_SUCCESS: {
            const goldenBySchema = { ...state.goldenBySchema, [action.payload.schemaId]: null };
            return { ...state, goldenBySchema, denominateResult: { success: true } };
        }
        case DENOMINATE_GOLDEN_NOMINAL_FAILURE:
            return { ...state, denominateResult: { success: false, ...action.payload } };
        case SET_PRECEDENCE_TIER_SUCCESS: {
            const dataSet = action.payload || {};
            return {
                ...state,
                tierByDataSet: { ...state.tierByDataSet, [dataSet.dataSetId]: dataSet.precedenceTier || null },
                setTierResult: { success: true },
            };
        }
        case SET_PRECEDENCE_TIER_FAILURE:
            return { ...state, setTierResult: { success: false, ...action.payload } };
        case SET_DATASET_ROLE_SUCCESS: {
            const dataSet = action.payload || {};
            return {
                ...state,
                roleByDataSet: { ...state.roleByDataSet, [dataSet.dataSetId]: dataSet.datasetRole || null },
                setRoleResult: { success: true },
            };
        }
        case SET_DATASET_ROLE_FAILURE:
            return { ...state, setRoleResult: { success: false, ...action.payload } };
        case TRUNCATE_DATASET_SUCCESS:
            return { ...state, truncateResult: { success: true, ...action.payload } };
        case TRUNCATE_DATASET_FAILURE:
            return { ...state, truncateResult: { success: false, ...action.payload } };
        case GET_GOLDEN_STEWARDSHIP_PERMISSION_SUCCESS:
            return { ...state, goldenStewardshipPermission: action.payload.permission };
        case GET_GOLDEN_STEWARDSHIP_PERMISSION_FAILURE:
            return { ...state, goldenStewardshipPermission: NO_GOLDEN_STEWARDSHIP_PERMISSION };
        default:
            return state;
    }
};
